<template>
  <div>
    <div class="score t-bold u-black u-center" :class="{'is-wiggle': isWiggle}">
      {{ score }} / {{ question }}
    </div>
  </div>
</template>

<script>
import Object3d from '@/plugins/Dom3d/mixin'

export default {
  mixins: [Object3d],

  data () {
    return {
      isWiggle: false
    }
  },

  computed: {
    question () {
      return this.$store.getters['data/answeredQuestion']
    },
    score () {
      return this.$store.getters['data/score']
    },

  },

  watch: {
    question () {
      this.isWiggle = true
      setTimeout(() => {
        this.isWiggle = false
      }, 500)
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'
@import '~@/styles/settings/easings'

.score
  font-size 30px
  line-height 30px
  border solid 2px $colors.white
  padding 16px 30px
  border-radius 20px
  width 160px
  background-color: $colors.white
  position absolute
  top 0
  left 0
  z-index 1
  
  &.is-wiggle
    animation wiggle ease-in-out-quad .5s

@keyframes wiggle
  0%
    transform rotate(0deg) translateZ(0)

  15%
    transform rotate(-10deg) translateZ(0)

  30%
    transform rotate(10deg) translateZ(0)

  50%
    transform rotate(-10deg) translateZ(0)

  70%
    transform rotate(10deg) translateZ(0)

  100%
    transform rotate(0deg) translateZ(0)
</style>